import { Button } from '@cox/core-ui8/dist/Button'

import { ReactButtonProps } from './types'
import withAEM from '../../hoc/withAEM'
import { getImageSrc } from '../../utils/local-util'
import { getTokenValues } from '../../utils/rule-builder-util'

const ReactButton = (props: ReactButtonProps): JSX.Element => {
  const { text, icon, tokenProperties, anchor, linkUrl, linkId, index } = props
  const tokenText = getTokenValues(text, tokenProperties) as string
  const tokenIcon = getTokenValues(icon, tokenProperties) as string
  const iconSrc = getImageSrc(tokenIcon)
  const tokenAnchor = getTokenValues(linkId || anchor, tokenProperties) as string
  const tokenButtonUrl = linkUrl && (getTokenValues(linkUrl, tokenProperties) as string)
  const ButtonWithAEM = withAEM(Button)
  return (
    <ButtonWithAEM
      {...props}
      text={tokenText}
      icon={tokenIcon}
      iconSrc={iconSrc}
      anchor={tokenAnchor}
      linkUrl={tokenButtonUrl}
      index={index}
      compName={'Button'}
    />
  )
}

export default ReactButton
